//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveMediaUrl } from '@/utils/mediaUrl'
import { TRIAL_WORD_LIMIT } from '@/utils/trialAccess'
import { buildMeanAndExampleHtml, MEAN_HIGHLIGHT_STYLE } from '@/utils/wordHighlight'
import gameSound from '@/utils/gameSound'
const PART_COLORS = [
  { bg: '#fff3e0', text: '#e65100', slotBg: 'rgba(255, 159, 67, 0.12)', border: 'rgba(255, 159, 67, 0.45)' },
  { bg: '#e8f5e9', text: '#2e7d32', slotBg: 'rgba(76, 175, 80, 0.1)', border: 'rgba(76, 175, 80, 0.4)' },
  { bg: '#e3f2fd', text: '#1565c0', slotBg: 'rgba(33, 150, 243, 0.1)', border: 'rgba(33, 150, 243, 0.4)' },
  { bg: '#fce4ec', text: '#c2185b', slotBg: 'rgba(233, 30, 99, 0.08)', border: 'rgba(233, 30, 99, 0.35)' },
  { bg: '#f3e5f5', text: '#7b1fa2', slotBg: 'rgba(156, 39, 176, 0.08)', border: 'rgba(156, 39, 176, 0.35)' }
]

export default {
  data () {
    return {
      book: {},
      wordList: [],
      index: 0,
      detailedWord: {},
      loading: true,
      showSummary: false,
      elapsedTime: 0,
      timer: null,
      isWordPower: null,
      splitParts: [],
      ideHints: [],
      letterSlots: [],
      pool: [],
      skippedCount: 0,
      solved: false,
      shaking: false,
      levelWrongAttempts: 0,
      levelStars: 0,
      totalStars: 0,
      unlockedImages: 0,
      levelStarRecords: [],
      dragging: false,
      dragTileId: null,
      dragGhost: { visible: false, char: '', x: 0, y: 0 },
      dropTargetIndex: -1,
      partColors: PART_COLORS,
      activeTile: null,
      dragMoved: false,
      soundEnabled: gameSound.isEnabled(),
      highlightStyle: MEAN_HIGHLIGHT_STYLE,
      compoundStep: 0,
      chunkJustSolved: false,
      chunkFlashLabel: '',
      chunkAdvanceTimer: null,
      chunkDetails: [],
      activeSplitParts: [],
      activeIdeHints: []
    }
  },
  computed: {
    scopeLabel () {
      if (this.$route.query.scope === 'book') return '全书闯关'
      if (this.$route.query.unitCn) return this.$route.query.unitCn
      return '拆分拼写'
    },
    progressPercent () {
      if (!this.wordList.length) return 0
      return Math.round(((this.index + 1) / this.wordList.length) * 100)
    },
    formattedTime () {
      const m = Math.floor(this.elapsedTime / 60)
      const s = this.elapsedTime % 60
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
    studiedCount () {
      return this.wordList.length
    },
    emptyTip () {
      if (this.$route.query.scope === 'book') return '暂无单词数据'
      if (this.$route.query.cellId) return '该章节暂无单词'
      return '请从练习页选择闯关范围'
    },
    isCompoundWord () {
      return /\s/.test((this.detailedWord.english || '').trim())
    },
    compoundChunks () {
      return (this.detailedWord.english || '').trim().split(/\s+/).filter(Boolean)
    },
    currentChunkDetail () {
      if (!this.isCompoundWord) return null
      return this.chunkDetails[this.compoundStep] || null
    },
    playHintTag () {
      if (this.isCompoundWord) {
        return `单独学习 · 第 ${this.compoundStep + 1}/${this.compoundChunks.length} 个词`
      }
      return '看联想 · 拼单词'
    },
    compoundStepTip () {
      return `先看联想与记忆，拼出第 ${this.compoundStep + 1} 个词（不提前透露拼写）`
    },
    normalizedEnglish () {
      return (this.detailedWord.english || '').trim().toLowerCase().replace(/\s+/g, '')
    },
    activeTarget () {
      return (this.activeSplitParts.length ? this.activeSplitParts : this.getActiveParts())
        .join('').toLowerCase().replace(/\s+/g, '')
    },
    canPlayLevel () {
      if (!this.splitParts.length || !this.normalizedEnglish) return false
      const joined = this.splitParts.join('').toLowerCase().replace(/\s/g, '')
      if (joined !== this.normalizedEnglish) return false
      if (this.isCompoundWord) {
        return !!(this.activeTarget && this.activeTarget.length)
      }
      return true
    },
    slotGroups () {
      const parts = this.activeSplitParts.length ? this.activeSplitParts : this.getActiveParts()
      const hints = this.activeIdeHints.length ? this.activeIdeHints : this.ideHints
      if (!parts.length) return []
      let slotIndex = 0
      return parts.map((part, localGi) => {
        const slots = []
        for (let i = 0; i < String(part).length; i++) {
          slots.push({ index: slotIndex++ })
        }
        const safeLabel = this.safeHintLabel(hints[localGi], part, localGi)
        return {
          part,
          label: safeLabel,
          gi: localGi,
          slots
        }
      })
    },
    wordImage () {
      return this.detailedWord.pmsImg || ''
    },
    processedMean () {
      if (!this.detailedWord || !this.detailedWord.mean) return ''
      return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedMean
    },
    processedExample () {
      if (!this.detailedWord || !this.detailedWord.example) return ''
      if (!this.detailedWord.mean) return this.escapeHtml(this.detailedWord.example)
      return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedExample
    },
    playMeanHtml () {
      const raw = this.isCompoundWord
        ? ((this.currentChunkDetail && this.currentChunkDetail.mean) || '')
        : (this.detailedWord.mean || '')
      if (!raw) return ''
      const example = this.isCompoundWord
        ? ((this.currentChunkDetail && this.currentChunkDetail.example) || '')
        : (this.detailedWord.example || '')
      return buildMeanAndExampleHtml(raw, example, { style: this.highlightStyle }).processedMean || this.escapeHtml(raw)
    },
    celebrateMeanHtml () {
      const raw = this.detailedWord.mean || ''
      if (!raw) return ''
      // 复合词结果页：词义截取；普通词完整展示
      if (this.isCompoundWord) {
        const short = this.shortenMean(raw, 52)
        return buildMeanAndExampleHtml(short, this.detailedWord.example, { style: this.highlightStyle }).processedMean ||
          this.escapeHtml(short)
      }
      return this.processedMean
    },
    playMemoryHtml () {
      // 复合词分步：展示当前词的记忆方法；普通词闯关中不占空间，留给结果页
      if (!this.isCompoundWord) return ''
      const detail = this.currentChunkDetail
      if (!detail || !detail.example) return ''
      if (!detail.mean) return this.escapeHtml(detail.example)
      const html = buildMeanAndExampleHtml(detail.mean, detail.example, { style: this.highlightStyle }).processedExample
      return html || this.escapeHtml(detail.example)
    },
    activeGuideItems () {
      const hints = this.activeIdeHints.length ? this.activeIdeHints : this.ideHints
      const parts = this.activeSplitParts.length ? this.activeSplitParts : this.splitParts
      const items = []
      hints.forEach((hint, pi) => {
        const text = this.safeHintLabel(hint, parts[pi], pi)
        items.push({ type: 'part', text, colorIndex: pi })
        if (pi < hints.length - 1) items.push({ type: 'plus', text: '+' })
      })
      return items
    },
    ideSegments () {
      return this.parseIdeSegments(this.detailedWord.wordIde, this.splitParts)
    },
    celebrateIdeItems () {
      const items = []
      if (this.isCompoundWord && this.chunkDetails.length) {
        this.compoundChunks.forEach((chunk, ci) => {
          const detail = this.chunkDetails[ci]
          const parts = detail
            ? this.parseSplitParts(detail.wordSplit, chunk)
            : [chunk]
          const segs = this.parseIdeSegments(detail && detail.wordIde, parts)
          const label = segs.map(s => s.hint || s.fullText).filter(Boolean).join('+') || chunk
          items.push({ type: 'part', text: `${chunk}：${label}` })
          if (ci < this.compoundChunks.length - 1) items.push({ type: 'plus', text: '+' })
        })
        return items
      }
      const segs = this.ideSegments
      segs.forEach((seg, pi) => {
        items.push({ type: 'part', text: seg.fullText || seg.hint || seg.english })
        if (pi < segs.length - 1) items.push({ type: 'plus', text: '+' })
      })
      return items
    },
    nextLevelLabel () {
      if (this.isWordPower == 0 && this.index >= 4) return '查看成绩单'
      if (this.index >= this.wordList.length - 1) return '查看成绩单'
      return '下一关 →'
    }
  },
  created () {
    this.book = { ...this.$route.query }
    this.isWordPower = this.$route.query.isWordPower
    this.loadWordList()
  },
  mounted () {
    this.$store.state.isShowBarKey = false
    document.addEventListener('mousemove', this.onTileMouseMove)
    document.addEventListener('mouseup', this.onTileMouseUp)
  },
  beforeDestroy () {
    this.stopTimer()
    this.clearChunkAdvanceTimer()
    document.removeEventListener('mousemove', this.onTileMouseMove)
    document.removeEventListener('mouseup', this.onTileMouseUp)
  },
  watch: {
    '$route' (to) {
      if (to.name !== 'wordSelect_display') return
      this.book = { ...to.query }
      this.resetGame(false)
      this.loadWordList()
    }
  },
  methods: {
    loadWordList () {
      const cellId = this.$route.query.cellId
      const scope = this.$route.query.scope
      if (cellId) {
        this.loadUnitWords(cellId)
      } else if (scope === 'book') {
        this.loadAllBookWords()
      } else {
        this.loading = false
      }
    },
    loadUnitWords (cellId) {
      this.loading = true
      this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: cellId })
        .then(result => {
          this.wordList = this.applyTrialWordCap(result || [])
          this.startFirstLevel()
        })
        .finally(() => { this.loading = false })
    },
    applyTrialWordCap (list) {
      const power = this.isWordPower
      if ((power === 0 || power === '0') && list.length > TRIAL_WORD_LIMIT) {
        return list.slice(0, TRIAL_WORD_LIMIT)
      }
      return list
    },
    loadAllBookWords () {
      this.loading = true
      this.$ajax.post(this.$api.getUnitListByBookId, { planId: this.$route.query.value })
        .then(units => {
          const unitList = units || []
          if (!unitList.length) {
            this.wordList = []
            return Promise.resolve()
          }
          const limited = unitList.some(u => u.isWordPower === 0 || u.isWordPower === '0')
          if (limited) {
            this.isWordPower = 0
            return this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: unitList[0].id })
              .then(words => {
                this.wordList = this.applyTrialWordCap(words || [])
                this.startFirstLevel()
              })
              .catch(() => { this.wordList = [] })
          }
          return Promise.all(
            unitList.map(unit =>
              this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: unit.id })
                .then(words => words || [])
                .catch(() => [])
            )
          ).then(results => {
            const merged = []
            const seen = new Set()
            results.flat().forEach(word => {
              if (!word || !word.id || seen.has(word.id)) return
              seen.add(word.id)
              merged.push(word)
            })
            this.wordList = merged
            this.startFirstLevel()
          })
        })
        .catch(() => { this.wordList = [] })
        .finally(() => { this.loading = false })
    },
    startFirstLevel () {
      if (!this.wordList.length) return
      this.index = 0
      this.startTimer()
      this.loadLevel(this.wordList[0].id)
    },
    loadLevel (wordId) {
      this.solved = false
      this.levelWrongAttempts = 0
      this.levelStars = 0
      this.shaking = false
      this.compoundStep = 0
      this.chunkJustSolved = false
      this.chunkFlashLabel = ''
      this.chunkDetails = []
      this.activeSplitParts = []
      this.activeIdeHints = []
      this.clearChunkAdvanceTimer()
      this.$ajax.get(this.$api.getPmsPmsWordsById + '?pkId=' + wordId).then(response => {
        this.detailedWord = response || {}
        if (this.detailedWord.pmsImg) {
          this.detailedWord.pmsImg = resolveMediaUrl(this.detailedWord.pmsImg)
        }
        const english = (this.detailedWord.english || '').trim()
        this.splitParts = this.parseSplitParts(this.detailedWord.wordSplit, english)
        this.ideHints = this.parseIdeHints(this.detailedWord.wordIde, this.splitParts)
        const boot = this.isCompoundWord
          ? this.loadChunkDetails().then(() => this.syncActivePuzzleData())
          : Promise.resolve(this.syncActivePuzzleData())
        return boot.then(() => {
          this.buildActivePuzzle()
          if (this.$route.query.value) {
            this.$ajax.post(this.$api.getPmsPmsStudyAdd, {
              wordId: wordId,
              wordUnitId: this.$route.query.value
            })
          }
        })
      })
    },
    loadChunkDetails () {
      const chunks = this.compoundChunks
      if (!chunks.length) {
        this.chunkDetails = []
        return Promise.resolve()
      }
      return Promise.all(chunks.map(chunk => this.fetchWordDetailByEnglish(chunk)))
        .then(list => {
          this.chunkDetails = list
        })
    },
    fetchWordDetailByEnglish (englishWord) {
      const fallback = {
        english: englishWord,
        mean: '',
        example: '',
        wordIde: '',
        wordSplit: '',
        pmsImg: ''
      }
      return this.$ajax.get(
        this.$api.messageMessageBoardgetByWord + '?word=' + encodeURIComponent(englishWord) + '&type=back'
      ).then(response => {
        if (!(response && response.length > 0)) return fallback
        const hit = response[0]
        const pkId = hit.id || hit.wordId
        if (!pkId) {
          return {
            english: hit.english || englishWord,
            mean: hit.mean || '',
            example: hit.example || '',
            wordIde: hit.wordIde || hit.word_ide || '',
            wordSplit: hit.wordSplit || hit.word_split || '',
            pmsImg: resolveMediaUrl(hit.pmsImg || hit.pms_img || '')
          }
        }
        return this.$ajax.get(this.$api.getPmsPmsWordsById + '?pkId=' + pkId).then(detail => {
          const d = detail || hit
          return {
            english: d.english || englishWord,
            mean: d.mean || '',
            example: d.example || '',
            wordIde: d.wordIde || d.word_ide || '',
            wordSplit: d.wordSplit || d.word_split || '',
            pmsImg: resolveMediaUrl(d.pmsImg || d.pms_img || '')
          }
        })
      }).catch(() => fallback)
    },
    chunkImageAt (ci) {
      const detail = this.chunkDetails[ci]
      return (detail && detail.pmsImg) || ''
    },
    shortenMean (text, maxLen = 40) {
      const plain = String(text || '').replace(/<[^>]+>/g, '').trim()
      if (!plain) return ''
      const first = plain.split(/[；;\n]/)[0].trim()
      if (first.length <= maxLen) return first
      return first.slice(0, maxLen) + '…'
    },
    safeHintLabel (hint, part, index) {
      const h = String(hint || '').trim()
      const p = String(part || '').trim()
      const chunk = this.isCompoundWord ? (this.compoundChunks[this.compoundStep] || '') : ''
      // 禁止直接展示英文答案（避免 keep / off 剧透）
      const norm = s => String(s || '').toLowerCase().replace(/\s+/g, '')
      if (h && chunk && norm(h) === norm(chunk)) {
        return `第${index + 1}段`
      }
      if (h && p && norm(h) === norm(p) && /^[a-zA-Z]+$/.test(h)) {
        return `第${index + 1}段`
      }
      if (h && /^[a-zA-Z\s]+$/.test(h) && this.isCompoundWord) {
        return `第${index + 1}段`
      }
      return h || `第${index + 1}段`
    },
    syncActivePuzzleData () {
      if (this.isCompoundWord) {
        const chunk = this.compoundChunks[this.compoundStep] || ''
        const detail = this.chunkDetails[this.compoundStep]
        let parts = []
        if (detail) {
          parts = this.parseSplitParts(detail.wordSplit, chunk)
        }
        // 若单词库拆分不可用，退回整词一块（字母格仍按字母填）
        if (!parts.length || parts.join('').toLowerCase().replace(/\s+/g, '') !== chunk.toLowerCase().replace(/\s+/g, '')) {
          parts = chunk ? [chunk] : []
        }
        this.activeSplitParts = parts
        this.activeIdeHints = this.parseIdeHints(detail && detail.wordIde, parts)
        // 短语词条里的对应段联想可作补充
        if ((!this.activeIdeHints.length || this.activeIdeHints.every((h, i) => this.isLatinOnly(h))) &&
          this.splitParts.length === this.compoundChunks.length) {
          const phraseHint = this.ideHints[this.compoundStep]
          if (phraseHint && !this.isLatinOnly(phraseHint) && parts.length === 1) {
            this.activeIdeHints = [phraseHint]
          }
        }
      } else {
        this.activeSplitParts = this.splitParts.slice()
        this.activeIdeHints = this.ideHints.slice()
      }
    },
    isLatinOnly (text) {
      return /^[a-zA-Z\s]+$/.test(String(text || '').trim())
    },
    parseSplitParts (wordSplit, english) {
      const normalized = (english || '').trim().toLowerCase().replace(/\s+/g, '')
      const spaceChunks = (english || '').trim().split(/\s+/).filter(Boolean)
      // 复合词优先按空格拆成词块，便于分步学习
      if (spaceChunks.length > 1) {
        if (wordSplit) {
          const parts = String(wordSplit).replace(/<[^>]+>/g, '').split('+').map(p => p.trim()).filter(Boolean)
          const joined = parts.join('').toLowerCase().replace(/\s+/g, '')
          if (parts.length === spaceChunks.length && joined === normalized) {
            return parts
          }
        }
        return spaceChunks
      }
      if (wordSplit) {
        const parts = String(wordSplit).replace(/<[^>]+>/g, '').split('+').map(p => p.trim()).filter(Boolean)
        const joined = parts.join('').toLowerCase().replace(/\s+/g, '')
        if (joined === normalized) return parts
      }
      return normalized.split('').filter(Boolean)
    },
    getActiveParts () {
      if (this.activeSplitParts.length) return this.activeSplitParts
      if (!this.splitParts.length) return []
      if (this.isCompoundWord) {
        const chunks = this.compoundChunks
        const step = Math.min(Math.max(this.compoundStep, 0), Math.max(chunks.length - 1, 0))
        return [chunks[step] || '']
      }
      return this.splitParts
    },
    clearChunkAdvanceTimer () {
      if (this.chunkAdvanceTimer) {
        clearTimeout(this.chunkAdvanceTimer)
        this.chunkAdvanceTimer = null
      }
    },
    parseIdeHints (wordIde, splitParts) {
      const segments = this.parseIdeSegments(wordIde, splitParts)
      return splitParts.map((part, i) => {
        const seg = segments[i]
        return seg && seg.hint ? seg.hint : part
      })
    },
    parseIdeSegments (wordIde, splitParts) {
      if (!splitParts.length) return []
      const rawSegments = []
      if (wordIde) {
        const raw = String(wordIde).replace(/<[^>]+>/g, '')
        raw.split(/\s*\+\s*/).forEach(seg => {
          if (seg.trim()) rawSegments.push(seg.trim())
        })
      }
      return splitParts.map((part, i) => {
        const seg = rawSegments[i] || ''
        const partUpper = String(part).toUpperCase()
        // PE(拼音)胖鹅 / PE（拼音）胖鹅
        let m = seg.match(/^([A-Za-z]+)\s*[（(]([^)）]+)[)）]\s*([\u4e00-\u9fa5\w]+)?/)
        if (m) {
          return {
            english: m[1].toUpperCase(),
            typeLabel: m[2],
            hint: m[3] || part,
            fullText: `${m[1].toUpperCase()}(${m[2]})${m[3] || ''}`
          }
        }
        // foot英文脚 / PE拼音胖鹅
        m = seg.match(/^([A-Za-z]+)(英文|拼音|象形|形象|音标|词根|口诀)([\u4e00-\u9fa5\w]+)?/)
        if (m) {
          return {
            english: m[1].toUpperCase(),
            typeLabel: m[2],
            hint: m[3] || part,
            fullText: `${m[1].toUpperCase()}(${m[2]})${m[3] || ''}`
          }
        }
        // 括号后中文：xxx(拼音)胖鹅 已处理；仅中文尾部
        const afterParen = seg.match(/[)）]\s*([\u4e00-\u9fa5A-Za-z0-9]+)/)
        const tailCn = seg.match(/([\u4e00-\u9fa5]+)\s*$/)
        const hint = afterParen ? afterParen[1] : (tailCn ? tailCn[1] : part)
        const english = /^[A-Za-z]+$/.test(seg.split(/[（(]/)[0]) ? seg.split(/[（(]/)[0].toUpperCase() : partUpper
        return {
          english: partUpper || english,
          typeLabel: '',
          hint,
          fullText: hint
        }
      })
    },
    shufflePool (letters) {
      const normalized = letters.map(c => String(c).toLowerCase()).filter(c => c && c.trim())
      const arr = normalized.map((char, i) => ({
        id: 'l' + i + '_' + char + '_' + Math.random().toString(36).slice(2, 7),
        char,
        used: false
      }))
      const original = normalized.join('')
      for (let attempt = 0; attempt < 8; attempt++) {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1))
          const tmp = arr[i]
          arr[i] = arr[j]
          arr[j] = tmp
        }
        if (arr.map(t => t.char).join('') !== original || arr.length <= 1) break
      }
      return arr
    },
    initLevelPuzzle () {
      const english = (this.detailedWord.english || '').trim()
      this.splitParts = this.parseSplitParts(this.detailedWord.wordSplit, english)
      this.ideHints = this.parseIdeHints(this.detailedWord.wordIde, this.splitParts)
      this.syncActivePuzzleData()
      this.buildActivePuzzle()
    },
    buildActivePuzzle () {
      const parts = this.activeSplitParts.length ? this.activeSplitParts : this.getActiveParts()
      const letters = parts.join('').split('').filter(c => c && c.trim())
      this.letterSlots = letters.map(() => null)
      if (letters.length) {
        this.pool = this.shufflePool(letters)
      } else {
        this.pool = []
      }
    },
    resetCurrentLevel () {
      if (this.solved || this.chunkJustSolved) return
      this.buildActivePuzzle()
    },
    getNextEmptySlot () {
      return this.letterSlots.findIndex(s => !s)
    },
    placeLetter (tile, slotIndex) {
      if (this.solved || this.chunkJustSolved || !this.canPlayLevel || tile.used || slotIndex < 0 || !tile.char) return
      if (this.letterSlots[slotIndex]) return
      this.$set(this.letterSlots, slotIndex, { char: tile.char, poolId: tile.id })
      tile.used = true
      this.checkAnswer()
    },
    clearSlot (slotIndex) {
      const slot = this.letterSlots[slotIndex]
      if (!slot || this.solved || this.chunkJustSolved) return
      const tile = this.pool.find(t => t.id === slot.poolId)
      if (tile) tile.used = false
      this.$set(this.letterSlots, slotIndex, null)
    },
    onTileTap (tile) {
      if (tile.used || this.solved || this.chunkJustSolved || this.dragMoved || !this.canPlayLevel || !tile.char) return
      const empty = this.getNextEmptySlot()
      if (empty >= 0) this.placeLetter(tile, empty)
    },
    onSlotTap (slotIndex) {
      if (this.solved || this.chunkJustSolved || this.dragging) return
      if (this.letterSlots[slotIndex]) {
        this.clearSlot(slotIndex)
      }
    },
    onTileTouchStart (e, tile) {
      if (tile.used || this.solved || this.chunkJustSolved) return
      this.activeTile = tile
      this.dragTileId = tile.id
      this.dragMoved = false
      this.dragging = true
      const touch = e.touches[0]
      this.dragGhost = { visible: true, char: tile.char, x: touch.clientX - 24, y: touch.clientY - 24 }
    },
    onTileTouchMove (e) {
      if (!this.activeTile || this.activeTile.used) return
      this.dragMoved = true
      const touch = e.touches[0]
      this.dragGhost.x = touch.clientX - 24
      this.dragGhost.y = touch.clientY - 24
      this.updateDropTarget(touch.clientX, touch.clientY)
    },
    onTileTouchEnd (e) {
      if (!this.activeTile) return
      const touch = e.changedTouches[0]
      if (this.dragMoved) {
        this.updateDropTarget(touch.clientX, touch.clientY)
        if (this.dropTargetIndex >= 0) {
          this.placeLetter(this.activeTile, this.dropTargetIndex)
        }
      }
      this.endDrag()
    },
    onTileMouseDown (e, tile) {
      if (tile.used || this.solved || this.chunkJustSolved) return
      this.activeTile = tile
      this.dragTileId = tile.id
      this.dragMoved = false
      this.dragging = true
      this.dragGhost = { visible: true, char: tile.char, x: e.clientX - 24, y: e.clientY - 24 }
    },
    onTileMouseMove (e) {
      if (!this.dragging || !this.activeTile || this.activeTile.used) return
      this.dragMoved = true
      this.dragGhost.x = e.clientX - 24
      this.dragGhost.y = e.clientY - 24
      this.updateDropTarget(e.clientX, e.clientY)
    },
    onTileMouseUp (e) {
      if (!this.dragging) return
      if (this.dragMoved && this.dropTargetIndex >= 0 && this.activeTile) {
        this.placeLetter(this.activeTile, this.dropTargetIndex)
      }
      this.endDrag()
    },
    onSlotDrop (slotIndex) {
      // 保留供桌面拖放；触屏改由 onTileTouchEnd + elementFromPoint 处理
      if (this.dragging && this.activeTile && this.dragMoved) {
        this.placeLetter(this.activeTile, slotIndex)
        this.endDrag()
      }
    },
    updateDropTarget (x, y) {
      const el = document.elementFromPoint(x, y)
      const slotBtn = el && el.closest ? el.closest('.spell-slot') : null
      if (slotBtn && slotBtn.dataset && slotBtn.dataset.index !== undefined) {
        this.dropTargetIndex = parseInt(slotBtn.dataset.index, 10)
      } else if (slotBtn) {
        const idx = slotBtn.getAttribute('data-index')
        this.dropTargetIndex = idx != null ? parseInt(idx, 10) : -1
      } else {
        this.dropTargetIndex = -1
      }
    },
    endDrag () {
      this.dragging = false
      this.dragTileId = null
      this.activeTile = null
      this.dropTargetIndex = -1
      this.dragGhost.visible = false
      setTimeout(() => { this.dragMoved = false }, 50)
    },
    checkAnswer () {
      if (this.letterSlots.some(s => !s)) return
      const answer = this.letterSlots.map(s => s.char).join('')
      if (answer === this.activeTarget) {
        this.onStepSuccess()
      } else {
        this.onLevelFail()
      }
    },
    onStepSuccess () {
      if (this.isCompoundWord && this.compoundStep < this.compoundChunks.length - 1) {
        this.chunkFlashLabel = ''
        this.chunkJustSolved = true
        gameSound.playCorrect()
        this.clearChunkAdvanceTimer()
        this.chunkAdvanceTimer = setTimeout(() => {
          this.chunkJustSolved = false
          this.compoundStep++
          this.syncActivePuzzleData()
          this.buildActivePuzzle()
          this.chunkAdvanceTimer = null
        }, 800)
        return
      }
      this.onLevelSuccess()
    },
    onLevelSuccess () {
      this.chunkJustSolved = false
      this.solved = true
      gameSound.playCorrect()
      if (this.levelWrongAttempts === 0) this.levelStars = 3
      else if (this.levelWrongAttempts === 1) this.levelStars = 2
      else this.levelStars = 1
      this.totalStars += this.levelStars
      this.levelStarRecords.push(this.levelStars)
      if (this.wordImage) this.unlockedImages++
    },
    onLevelFail () {
      if (this.chunkJustSolved) return
      this.levelWrongAttempts++
      gameSound.playWrong()
      this.shaking = true
      setTimeout(() => {
        this.shaking = false
        this.letterSlots.forEach((slot, i) => {
          if (slot) this.clearSlot(i)
        })
      }, 600)
    },
    skipLevel () {
      if (this.solved || this.showSummary || this.chunkJustSolved) return
      this.skippedCount++
      this.levelStarRecords.push(0)
      this.goNextLevel()
    },
    goNextLevel () {
      this.clearChunkAdvanceTimer()
      if (this.isWordPower == 0 && this.index >= 4) {
        this.finishGame()
        return
      }
      if (this.index >= this.wordList.length - 1) {
        this.finishGame()
        return
      }
      this.index++
      this.loadLevel(this.wordList[this.index].id)
    },
    finishGame () {
      this.stopTimer()
      this.showSummary = true
    },
    startTimer () {
      this.stopTimer()
      this.elapsedTime = 0
      this.timer = setInterval(() => { this.elapsedTime++ }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    resetGame (keepWordList) {
      this.stopTimer()
      this.showSummary = false
      this.index = 0
      this.totalStars = 0
      this.unlockedImages = 0
      this.skippedCount = 0
      this.levelStarRecords = []
      if (!keepWordList) this.wordList = []
    },
    restartGame () {
      this.resetGame(true)
      this.startFirstLevel()
    },
    goReturn () {
      // 从练习 Tab 进入时必须回到 /practice（有底部导航），避免落到无 Tab 的 display 页需再点一次
      if (this.$route.query.source === 'practice') {
        this.$router.push({ path: '/practice', query: { hideTrans: 'true' } })
        return
      }
      if (this.$route.query.source) {
        this.$router.push({ path: '/practiceSelectList_display?hideTrans=true', query: this.$route.query })
        return
      }
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    },
    toggleSound () {
      this.soundEnabled = gameSound.toggle()
    },
    escapeHtml (unsafe) {
      return String(unsafe || '').replace(/[&<"'>]/g, m => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[m]))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/word/practice/wordSelect.vue